<div class="dropdown" dropdown #dropdown="bs-dropdown">
  <button class="tool-column"
          dropdownToggle
          data-toggle="dropdown"
          tooltip
          tooltipPosition="bottom"
          [tooltipText]="'main.tabBar.view.label.perspective' | translate">
    <div class="tool-row">
      <app-svg-icon type="perspective"/>
      <app-svg-icon type="caret_down" size="medium-small"/>
    </div>
    <span class="tool-row">{{"main.tabBar.view.label.perspective" | translate}}</span>
  </button>
  <ul *dropdownMenu class="dropdown-menu dropdown-menu-left">
    <li>
      <a class="dropdown-item" (click)="viewAll()"
         appActionLogId="main.tabBar.view"
         appActionLogParam="all"
         id="main-menu-action-view-all">
        <app-svg-icon type="legacy-cube-iso" class="d-inline pe-2"/>
        <span>{{'main.tabBar.view.label.view_all' | translate}}</span>
      </a>
    </li>
    <li>
      <a class="dropdown-item" (click)="viewSelected()"
         appActionLogId="main.tabBar.view"
         appActionLogParam="selected"
         id="main-menu-action-view-selected">
        <app-svg-icon type="legacy-cube-iso" class="d-inline pe-2"/>
        <span>{{'main.tabBar.view.label.view_selected' | translate}}</span>
      </a>
    </li>
    <li>
      <a class="dropdown-item" (click)="setCameraDefaultPosition()"
         appActionLogId="main.tabBar.view.label.default_position"
         appActionLogParam="default"
         data-gatm="viewActions.default_position"
         id="main-menu-action-default-position">
        <app-svg-icon type="scan" class="d-inline pe-2"/>
        <span>{{'main.tabBar.view.label.default_position' | translate}}</span>
      </a>
    </li>
    <li>
      <a class="dropdown-item" (click)="view('isometric')"
         appActionLogId="main.tabBar.view"
         appActionLogParam="isometric"
         data-gatm="viewActions.views.isometric_direction"
         id="main-menu-action-view-isometric">
        <app-svg-icon type="legacy-cube-iso" class="d-inline pe-2"/>
        <span>{{'main.tabBar.view.label.isometric_direction' | translate}}</span>
      </a>
    </li>
    <li>
      <a class="dropdown-item" (click)="view('top')"
         appActionLogId="main.tabBar.view"
         appActionLogParam="top"
         data-gatm="viewActions.views.top_direction"
         id="main-menu-action-view-top">
        <app-svg-icon type="legacy-cube-top" class="d-inline pe-2"/>
        <span>{{'main.tabBar.view.label.top_direction' | translate}}</span>
      </a>
    </li>
    <li>
      <a class="dropdown-item" (click)="view('bottom')"
         appActionLogId="main.tabBar.view"
         appActionLogParam="bottom"
         data-gatm="viewActions.views.bottom_direction"
         id="main-menu-action-view-bottom">
        <app-svg-icon type="legacy-cube-bottom" class="d-inline pe-2"/>
        <span>{{'main.tabBar.view.label.bottom_direction' | translate}}</span>
      </a>
    </li>
    <li>
      <a class="dropdown-item" (click)="view('front')"
         appActionLogId="main.tabBar.view"
         appActionLogParam="front"
         data-gatm="viewActions.views.front_direction"
         id="main-menu-action-view-front">
        <app-svg-icon type="legacy-cube-front" class="d-inline pe-2"/>
        <span>{{'main.tabBar.view.label.front_direction' | translate}}</span>
      </a>
    </li>
    <li>
      <a class="dropdown-item" (click)="view('back')"
         appActionLogId="main.tabBar.view"
         appActionLogParam="back"
         data-gatm="viewActions.views.back_direction"
         id="main-menu-action-view-back">
        <app-svg-icon type="legacy-cube-back" class="d-inline pe-2"/>
        <span>{{'main.tabBar.view.label.back_direction' | translate}}</span>
      </a>
    </li>
    <li>
      <a class="dropdown-item" (click)="view('right')"
         appActionLogId="main.tabBar.view"
         appActionLogParam="right"
         data-gatm="viewActions.views.right_direction"
         id="main-menu-action-view-right">
        <app-svg-icon type="legacy-cube-right" class="d-inline pe-2"/>
        <span>{{'main.tabBar.view.label.right_direction' | translate}}</span>
      </a>
    </li>
    <li>
      <a class="dropdown-item" (click)="view('left')"
         appActionLogId="main.tabBar.view"
         appActionLogParam="left"
         data-gatm="viewActions.views.left_direction"
         id="main-menu-action-view-left">
        <app-svg-icon type="legacy-cube-left" class="d-inline pe-2"/>
        <span>{{'main.tabBar.view.label.left_direction' | translate}}</span>
      </a>
    </li>
  </ul>
</div>
